import saMessages from "../locales/pt_BR.json";

const ptLang = {
	messages: {
		...saMessages,
	},
	locale: "pt",
};
export default ptLang;
